/** Texto con formato de respuestas y plantillas: HTML del editor, o texto plano de antes (la API lee ambos). */
const HTML_START = /^\s*<(p|h[1-6]|ul|ol|blockquote|table|div)[\s>/]/i;
export const isRichHtml = (body: string) => HTML_START.test(body);

/** Sin texto, variables ni tablas: lo que el editor deja cuando se borra todo (`<p></p>`). */
export const isRichEmpty = (body: string | undefined | null) => {
  if (!body?.trim()) return true;
  if (!isRichHtml(body)) return false;
  return !/<table|data-variable=|<li/i.test(body) && !body.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
};

/** Texto visible (para contar caracteres): sin etiquetas. */
export const richPlainText = (body: string) => (isRichHtml(body) ? body.replace(/<\/(p|h[1-6]|li|tr)>/gi, ' ').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>') : body).trim();

const esc = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
/**
 * Texto plano de antes del editor → HTML del editor, igual que lo lee la API: una línea en blanco separa párrafos, el
 * salto simple se respeta y `{{a.b}}` pasa a ser una ficha de variable.
 */
export const plainToHtml = (text: string) => text.replace(/\r\n/g, '\n').split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean)
  .map((p) => `<p>${esc(p).replace(/{{\s*([\w.]+)\s*}}/g, '<span data-variable="$1"></span>').replace(/\n/g, '<br>')}</p>`).join('');

/** Lo que recibe el editor: el HTML tal cual, o el texto de antes convertido. */
export const toEditorHtml = (body: string) => (isRichHtml(body) || !body.trim() ? body : plainToHtml(body));

/** Reemplaza las variables (fichas o `{{a.b}}`) con datos de ejemplo, para la vista previa. */
export const renderSample = (body: string, sample: Record<string, string>) => {
  const val = (k: string) => sample[k] ?? `[${k}]`;
  return body.replace(/<span[^>]*data-variable="([\w.]+)"[^>]*>.*?<\/span>/gi, (_m, k: string) => val(k)).replace(/{{\s*([\w.]+)\s*}}/g, (_m, k: string) => val(k));
};

/** Dirección de un enlace: http(s) o correo; sin esquema se toma como https. Otros esquemas (javascript:, data:…) no. */
export const normalizeHref = (raw: string): string | null => {
  const v = raw.trim();
  if (!v) return null;
  if (/^(https?:\/\/|mailto:)/i.test(v)) return v;
  if (/^[^\s@/]+@[^\s@/]+\.[^\s@/]+$/.test(v)) return `mailto:${v}`;
  if (/^[a-z][\w+.-]*:/i.test(v)) return null;
  return `https://${v}`;
};

/**
 * Una plantilla de respuesta lleva `{{response.body}}` para el correo; al insertarla en la propia respuesta esa ficha
 * no tiene sentido (quedaría vacía): se quita y deja el párrafo libre para redactar.
 */
export const withoutResponseBody = (body: string) => body.replace(/<span\b[^>]*\bdata-variable="response\.body"[^>]*>[\s\S]*?<\/span>|{{\s*response\.body\s*}}/g, '');
